import { createApi } from "@reduxjs/toolkit/query/react";
import {
  BackendCart,
  BackendCartItem,
  Cart,
  InformeCartItem
} from "../models/cart";
import customFetchBase from "./customFetchBase";

// Type for backend response
export interface BackendResponse<T> {
  message: string;
  status: 'success' | 'error';
  data: T;
}



export const cartApi = createApi({
  reducerPath: "cartApi",
  baseQuery: customFetchBase,
  tagTypes: ["Cart"],
  endpoints: (builder) => ({
    getCart: builder.query<BackendResponse<BackendCart>, void>({
      query() {
        return {
          url: `informe/tempCart`,
          method: "GET",
        };
      },

      providesTags: ["Cart"],
    }),

    addItemToCart: builder.mutation<BackendResponse<BackendCartItem>, InformeCartItem>({
      query(data) {
        //const {  ...item } = data;
        const backendItem = data//toBackendCartItem(item, clientId || "");

        return {
          url: "informe/tempCart",
          method: "POST",
          body: backendItem,
        };
      },
      invalidatesTags: ["Cart"],
    }),

    updateItemInCart: builder.mutation<BackendResponse<BackendCartItem>, { informe: any }>({
      query({ informe }) {

        return {
          url: `informe/tempCart`,
          body: informe,
          method: "PUT",
        };
      },
      invalidatesTags: ["Cart"],
    }),

    removeItemFromCart: builder.mutation<void, { informeId: string }>({
      query({ informeId }) {
        return {
          url: `informe/tempCart`,
          params: { uuid: informeId },
          method: "DELETE",
        };
      },
      invalidatesTags: ["Cart"],
    }),

    // Since there's no direct "clear cart" endpoint, we'll provide a helper
    // endpoint that can be used by components to trigger the removal of all items
    clearCart: builder.mutation<void, { itemIds: string[] }>({
      query({ itemIds }) {
        // In a real implementation, you might want to add a bulk delete endpoint on the backend
        // For now, we'll call the deleteItem endpoint for each item in a sequence
        return {
          url: `informe/tempCart`,
          params: { uuid: itemIds.join(",") }, // Assuming the backend can handle this
          method: "DELETE",
        };
      },
      invalidatesTags: ["Cart"],
    }),
  }),
});

export const {
  useGetCartQuery,
  useAddItemToCartMutation,
  useUpdateItemInCartMutation,
  useRemoveItemFromCartMutation,
  useClearCartMutation
} = cartApi;